/**
 * 主题分类、语言的展示文案和标签颜色（antd 预设色名，跟随主题）
 */
export const THEME_CATEGORIES: Record<string, { label: string; color: string }> = {
  slice_of_life: { label: '日常生活', color: 'green' },
  adventure: { label: '冒险故事', color: 'orange' },
  fantasy: { label: '奇幻故事', color: 'purple' },
  educational: { label: '教育内容', color: 'blue' }
}

export const CATEGORY_OPTIONS = Object.entries(THEME_CATEGORIES).map(([value, { label }]) => ({ value, label }))

// 列表筛选只有前三个分类（与旧版一致）
export const CATEGORY_FILTER_OPTIONS = CATEGORY_OPTIONS.filter((option) => option.value !== 'educational')

export const ACTIVE_STATUS_OPTIONS = [
  { value: true, label: '启用' },
  { value: false, label: '禁用' }
]

export function categoryLabel(category: string) {
  return THEME_CATEGORIES[category]?.label ?? category
}

export function categoryColor(category: string) {
  return THEME_CATEGORIES[category]?.color ?? 'default'
}

export const LOCALE_OPTIONS = [
  { value: 'en-US', label: '英语' },
  { value: 'zh-CN', label: '中文' }
]

export function formatThemeDate(value: string | undefined) {
  if (!value) return '—'
  return new Date(value).toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}
